module.exports = __webpack_public_path__ + "img/symbol_0.bd2f71e3.png";